import BoxInfo from '@/components/boxInfo/boxInfo';
import IconBox from '@/components/iconBox';
import { COMPANY_CONFIG } from '@/modules/company/entities/enums/company';
import useCompany from '@/shared/hooks/useCompany/useCompany';
import { analytics } from '@/shared/telemetry/analytics/analytics';
import ICONS from '@/shared/entities/constants/icons';
import React from 'react';
import { Button, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';
import lamp from '@/assets/images/lamp.svg';

const Insights: React.FC = () => {
  const { getFirstCompanyConfigByKey } = useCompany();
  const externalLinkInsight = getFirstCompanyConfigByKey(COMPANY_CONFIG.EXTERNAL_LINK_INSIGHTS);

  const renderInsightsAction = () => {
    if (externalLinkInsight) {
      const { link } = JSON.parse(externalLinkInsight);
      const label = 'Ver dados de saúde';
      return (
        <BoxInfo>
          <Grid alignContent='justify' alignItems='center'>
            <Grid gap={16} alignItems='center'>
              <IconBox iconImageUrl={lamp} />

              <Grid column alignContent='center'>
                <Text
                  title
                  value='Acompanhe indicadores de saúde de sua empresa'
                  color='colorDefault'
                />
                <Text
                  size='medium'
                  value='Visualize os principais dados de utilização e transforme números em estratégias de cuidados'
                />
              </Grid>
            </Grid>

            <Button
              label={label}
              icon={ICONS.TRENDING_UP}
              onClick={() => {
                analytics.track('INSIGHTS_ACCESS', { label: label });
                window.open(link || '', 'new');
              }}
            />
          </Grid>
        </BoxInfo>
      );
    }

    return null;
  };

  return externalLinkInsight ? renderInsightsAction() : null;
};

export default Insights;
